import {TOP_NAV_HEIGHT} from '../../util/constants';

export const VIEW_BAR_HEIGHT = 57;
export const NAV_AND_VIEW_BAR_OFFSET = TOP_NAV_HEIGHT + VIEW_BAR_HEIGHT;

/**
 * note: on narrow screens, the project sidebar is moved from
 * left side to the top. offset width (when on left) and height
 * (when on top) are the same either way.
 */
export const PROJECT_BAR_OFFSET = 56;
